import React, { useState } from 'react';
import { Leaf, ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Footer } from '@/components/Footer';
import { CookieBanner } from '@/components/CookieBanner';

export const PageLayout = ({ title, children }) => {
    const [isCookieSettingsOpen, setIsCookieSettingsOpen] = useState(false);

    const handleOpenCookieSettings = () => {
        localStorage.removeItem('cookie_consent');
        setIsCookieSettingsOpen(true);
    };

    const handleCloseCookieSettings = () => {
        setIsCookieSettingsOpen(false);
    };

    return (
        <div className="min-h-screen bg-background">
            {/* Header */}
            <header className="bg-card/95 backdrop-blur-md shadow-soft sticky top-0 z-50">
                <div className="section-container">
                    <div className="flex items-center justify-between h-16 md:h-18">
                        {/* Logo */}
                        <Link
                            to="/"
                            className="flex items-center gap-2 text-primary font-bold text-lg md:text-xl"
                        >
                            <Leaf className="h-6 w-6" />
                            <span>DetoxTeeTest</span>
                        </Link>

                        {/* Back to Home */}
                        <Link
                            to="/"
                            className="inline-flex items-center gap-2 text-sm text-muted-foreground hover:text-primary transition-colors"
                        >
                            <ArrowLeft className="h-4 w-4" />
                            Zurück zur Startseite
                        </Link>
                    </div>
                </div>
            </header>

            {/* Main Content */}
            <main className="section-container py-12 md:py-16">
                <div className="max-w-4xl mx-auto">
                    {/* Page Title */}
                    <h1 className="text-3xl md:text-4xl font-bold text-foreground mb-8">
                        {title}
                    </h1>

                    {/* Content */}
                    <div className="bg-card rounded-xl shadow-md p-6 md:p-10">
                        <div className="prose prose-lg max-w-none text-foreground">
                            {children}
                        </div>
                    </div>
                </div>
            </main>

            {/* Footer - Same as HomePage */}
            <Footer onOpenCookieSettings={handleOpenCookieSettings} />

            {/* Cookie Consent Banner */}
            <CookieBanner
                isOpen={isCookieSettingsOpen}
                onClose={handleCloseCookieSettings}
            />
        </div>
    );
};

